import React from 'react';

import { Container } from './AvatarIcon.styles';

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  image: string;
}

export default function AvatarIcon({ image, ...props }: ContainerProps) {
  return (
    <Container {...props}>
      <img src={image} alt="avatar" referrerPolicy="no-referrer" {...props} />
    </Container>
  );
}
